/* eslint-disable react/jsx-no-target-blank */
import {useEffect} from 'react'
import {ILayout, useLayout} from '../../core'
import {VERSION_APP} from '../../../../app/tfi/helpers/consts'

// Brand name and the copyright sign are not translatable content (guía §17.3).
const BRAND = 'Policy Tools'
const COPYRIGHT_SIGN = '©'
const formatCopyright = (year: number) => `${year}${COPYRIGHT_SIGN}`

const Footer = () => {
  const {config} = useLayout()
  useEffect(() => {
    updateDOM(config)
  }, [config])
  return (
    <>
      <div className='text-dark order-2 order-md-1'>
        <span className='text-muted fw-semibold me-1'>
          {formatCopyright(new Date().getFullYear())}
        </span>
        <a href='/#' className='text-gray-800 text-hover-primary' rel='noopener noreferrer'>
          {BRAND}
        </a>
      </div>

      <ul className='menu menu-gray-600 menu-hover-primary fw-semibold order-1'>
        <li className='menu-item'>{VERSION_APP}</li>
      </ul>
    </>
  )
}

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add('data-kt-app-footer-fixed', 'true')
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add('data-kt-app-footer-fixed-mobile', 'true')
  }
}

export {Footer}
